import { render } from "./ProfaceGet.vue?vue&type=template&id=6a7876df&scoped=true"
import script from "./ProfaceGet.vue?vue&type=script&lang=js"
export * from "./ProfaceGet.vue?vue&type=script&lang=js"

import "./ProfaceGet.vue?vue&type=style&index=0&id=6a7876df&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7876df"]])

export default __exports__